import React from 'react';
import { Size, Icon } from '@americanexpress/aqx-components';
import customStyles from 'page_modules/compare/__styles__/attributesTable.scss?modules';

const BenefitIcon = ({ isDash }) => {
  const iconName = isDash ? 'dls-icon-minus' : 'dls-icon-check';
  const clsName = isDash ? customStyles.dash : customStyles.checkMark;
  const ariaLabel = isDash ? 'Benefit not included' : 'Benefit included';
  const sizeVal = isDash ? Size.SM : Size.MD;
  return (
    <div className={clsName} aria-label={ariaLabel} role="img">
      <Icon directory="dls" $size={sizeVal} imageName={iconName} />
    </div>
  );
};

export default React.memo(BenefitIcon);
